export function getActiveAddonComponent() {
	if (window.addonEventReturnComponent) {
		return window.addonEventReturnComponent;
	}

	return null;
}
